import React from 'react';
import { get } from 'lodash';
import { components } from 'react-select';

function MultiValueRemove(props) {
  var value = get(props, 'selectProps.value');

  if (Array.isArray(value) && value.length > 1) {
    return /*#__PURE__*/React.createElement(components.MultiValueRemove, props, ",");
  }

  return /*#__PURE__*/React.createElement(components.MultiValueRemove, props, " ");
}

export default MultiValueRemove;
//# sourceMappingURL=MultiValueRemove.js.map
